import { api } from "./interceptors";
const orderService = {
  /**
   * Get orders
   * @param {number} page - Page number for pagination (default: 1)
   * @returns {Promise<Array>} - Returns nearby stores data as array
   */
  GetAll: async (page = 1, page_size = 1000) => {
    try {
      const response = await api.get("/orders/", {
        params: { page, page_size },
      });
      // Handle the new API response format: { success: true, data: { data: [...] } }
      const responseData = response.data;
      if (responseData && responseData.success && responseData.data && Array.isArray(responseData.data.data)) {
        return responseData.data.data;
      } else {
        // Fallback for direct array response
        return responseData;
      }
    } catch (error) {
      console.error('Error fetching Orders from API:', error);

    }
  },

  Get: async (public_id) => {
    try {
      const response = await api.get(`/orders/${public_id}/`);
      return response
    } catch (error) {
      console.error('Error fetching specific Order from API:', error);
    }
  },

  Redeem: async (public_id) => {
    try {
      const response = await api.post(`/orders/${public_id}/redeem/`);
      return response;
    } catch (error) {
      console.error('Error redeeming Order from API:', error);
    }
  },
  Cancel: async (public_id) => {
    try {
      const response = await api.post(`/orders/${public_id}/cancel/`);
      return response;
    } catch (error) {
      console.error('Error Cancelling Order from API:', error);
    }
  }
};

export default orderService;